
export default {
    methods: {
        removeHiddenSpace(e) {

            try {
                var result = e.trim()
                result = result.replace(/(​|“|”|‘|’)/gim, "")
                if (result) {
                    e = result
                    return result
                } else return "";
            } catch (error) {
                return e;
            }
        },
    }
}
